import { apiPortal } from './api';

type SignInContribuinteRequest = {
  cpfCnpj: string;
  senha: string;
};

export const signInContribuinteRequest = async (
  contribuinteRequest: SignInContribuinteRequest
): Promise<{
  tokenAccess: string;
  tokenRefresh: string;
}> => {
  const { data } = await apiPortal.post('/api/portal/contribuintes/login', contribuinteRequest);

  return data;
};

export const buscaInfoContribuinteRequest = async (): Promise<any> => {
  const { data } = await apiPortal.get('/api/portal/contribuintes/auth/info');
  return data;
};

export const atualizarTokenAccessRequest = async (
  tokenRefresh: string
): Promise<any> => {
  const {data: { tokenAccess }} = await apiPortal.post('/api/portal/contribuintes/token-refresh', {
    token: tokenRefresh,
  });

  return tokenAccess;
};

export const alterarSenhaContribuinteRequest = async (senha: string): Promise<void> => {
  await apiPortal.post('/api/portal/contribuintes/alterar-senha', { senha });
};
